import { render, staticRenderFns } from "./UiModalSign.vue?vue&type=template&id=1fd76fe2&"
import script from "./UiModalSign.vue?vue&type=script&lang=js&"
export * from "./UiModalSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports